module.exports = new __parcel__URL__("ride_8.e0a39ea5.mp3").toString();